<template>
    <Selector
        :options="options"
        :class="{ disabled: isDisabled, locked: isLocked }"
        :renderToPortal="false"
        :closeOnSelect="closeOnSelect"
        :popupTestName="testName"
        @select="onSelect"
    >
        <template #input="{ toggle, isOpen }">
            <TextField
                :size="size"
                class="selector"
                :value="stringValue"
                :iconRight="getIconRight(isOpen)"
                :placeholder="placeholder"
                isReadOnly
                :isSelectable="false"
                :color="color"
                :isDisabled="isDisabled"
                :testId="`selector-field-${testName}`"
                @click.native.stop.prevent="toggle"
            />
        </template>
        <template #option="{ option, select }">
            <DropdownItem
                :key="option"
                :isSelected="option === value"
                :title="displayOptionConverter ? displayOptionConverter(option) : option"
                @click="select(option)"
            />
        </template>
    </Selector>
</template>
<script lang="ts">
    import { Prop, Emit, Component, Vue } from 'vue-property-decorator';
    import DropdownItem from '@/ui-kit/dropdown/items/DropdownItem.vue';
    import TextField from '@/ui-kit/text-field/TextField.vue';
    import Selector from '@/ui-kit/selector/Selector.vue';
    import '@eloomi/icons/arrows/arrows-chevron-up-regular';
    import '@eloomi/icons/arrows/arrows-chevron-down-regular';
    import '@eloomi/icons/products-pages/products-and-pages-course-builder-lock-bold-small';

    @Component({
        components: {
            DropdownItem,
            Selector,
            TextField,
        },
    })
    export default class BasicSelector extends Vue {
        @Prop({ default: () => [] }) options!: any[];
        @Prop() displayOptionConverter?: (any) => string;
        @Prop({ default: '' }) value: any;
        @Prop({ default: '' }) placeholder!: string;
        @Prop({ default: false, type: Boolean }) closeOnSelect!: boolean;
        @Prop({ default: false, type: Boolean }) isDisabled!: boolean;
        @Prop({ default: 'default' }) color!:
            | 'default'
            | 'info'
            | 'success'
            | 'warning'
            | 'danger'
            | 'bright'
            | 'primary';
        @Prop({ default: 'large' }) size!: 'small' | 'large';
        @Prop({ default: undefined }) testName?: string;
        @Prop({ default: false, type: Boolean }) isLocked!: boolean;

        public get stringValue() {
            return this.displayOptionConverter ? this.displayOptionConverter(this.value) : this.value?.toString() || '';
        }

        public getIconRight(isOpen: boolean) {
            if (this.isLocked) {
                return 'elm-products-and-pages-course-builder-lock-bold-small-icon';
            }

            return isOpen ? 'elm-arrows-chevron-up-regular-icon' : 'elm-arrows-chevron-down-regular-icon';
        }

        @Emit('select')
        onSelect(option) {
            return option;
        }
    }
</script>

<style scoped lang="less">
    .selector {
        cursor: pointer;

        &.disabled {
            cursor: not-allowed;
        }

        &.locked {
            pointer-events: none;
        }
    }
</style>
